import * as React from "react";
import { MyAccountLayout, OnlyOnClient } from "@grandvisionhq/my-account";
import { monetate } from "@grandvisionhq/svc-monetate";
const AuthPageLayout = ({ children, hasTwoColumns }) => {
  const formWrapperClassName = hasTwoColumns ? "myaccount__form-wrapper myaccount__form-wrapper--double" : "myaccount__form-wrapper";
  React.useEffect(() => {
    monetate().commitMonetateEvent("my-account");
  }, []);
  return /* @__PURE__ */ React.createElement(MyAccountLayout, null, /* @__PURE__ */ React.createElement("div", { className: formWrapperClassName }, /* @__PURE__ */ React.createElement(OnlyOnClient, null, children)));
};
export {
  AuthPageLayout as A
};
//# sourceMappingURL=auth-page.js.map
